import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import seven from '../assets/svg/projects/seven.svg'
import eleven from '../assets/svg/projects/eleven.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'HackerRank Automation',
        projectDesc: 'In this project, we will be submitting HackerRank code with our automation script that we have written with Puppeteer using Nodejs.',
        tags: ['Node JS'],
        code: 'https://github.com/sunidhi014/Hackerrank-Automation-using-JS-and-Puppeteer',
        demo: 'https://github.com/sunidhi014/Hackerrank-Automation-using-JS-and-Puppeteer',
        image: two
    },
    {
        id: 2,
        projectName: 'Weather App',
        projectDesc: 'Developed an Android app for real-time weather forecasts using the OpenWeatherMap API. Implemented geolocation services to provide weather information based on the user’s current location.',
        tags: ['React'],
        code: 'https://github.com/sunidhi014/Weather-App',
        demo: 'https://github.com/sunidhi014/Weather-App',
        image: three
    },
    {
        id: 3,
        projectName: 'Stock Market App',
        projectDesc: 'This project aims to forecast future trends in Apple stock prices based on historical data. Leveraging machine learning techniques, specifically time series analysis, it uses historical stock prices and related factors to predict future price movements.',
        tags: ['Python', 'Scikit-learn', 'Pandas', 'Matplotlib' ],
        code: 'https://github.com/sunidhi014/Time_Series_Forecasting_ml',
        demo: 'https://github.com/sunidhi014/Time_Series_Forecasting_ml',
        image: seven
    },
    {
        id: 4,
        projectName: 'KanBan',
        projectDesc: 'Implementing a Kanban board with Angular can be an effective way to manage tasks and workflows in web applications.',
        tags: ['Angular'],
        code: 'https://github.com/sunidhi014/KanBan-in-Angular-cli',
        demo: 'https://github.com/sunidhi014/KanBan-in-Angular-cli',
        image: four
    },
    {
        id: 5,
        projectName: 'Calculator App',
        projectDesc: 'A Calculator developed in Go using the Fyne library for the user interface and the govaluate library for evaluating mathematical expressions. It offers users a visually intuitive interface to perform arithmetic calculations efficiently.',
        tags: ['Go', 'Fyne'],
        code: 'https://github.com/sunidhi014/Calculator-in-Go-and-Fyne',
        demo: 'https://github.com/sunidhi014/Calculator-in-Go-and-Fyne',
        image: eleven
    },
    {
        id: 6,
        projectName: 'To-Do App',
        projectDesc: 'The Angular To-Do List App is a web-based application developed using the Angular framework. It enables users to manage tasks by creating, updating, marking as complete, and deleting items from their to-do list.',
        tags: ['Angular'],
        code: 'https://github.com/sunidhi014/Todo-app-in-Angular-cli',
        demo: 'https://github.com/sunidhi014/Todo-app-in-Angular-cli',
        image: one
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/